import { get } from 'lodash';
export function state(initialState) {
  return {
    metals: null,
    alloyLists: get(initialState, 'global.alloyLists'),
    alloyGroupDetails: get(initialState, 'global.alloyGroupDetails'),
    alloyDetails: get(initialState, 'global.alloyDetails'),
  };
}
